import {getMomentTime} from 'app/utils/time/getMomentTime';
import moment from 'moment';

const getMomentDiffHours = (val: number, timezone_name = 'UTC'): number => {
    const momentTime = getMomentTime(val, timezone_name);

    return moment.duration(moment().diff(momentTime)).asHours();
};

export default getMomentDiffHours;
